import { React, useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import XLSX from 'sheetjs-style';
import CloseIcon from '@mui/icons-material/Close';
import Moment from 'moment';

// Material-UI components
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    Box,
    Tooltip,
    Modal,
    Autocomplete,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';
import Iconify from '../../../components/Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../../components/Page';
import AppCache from '../../../services/AppCache';
import StickyHeader from "../../../components/Common/StickyHeader";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflow: 'auto',
    borderRadius: '8px',
};
export default function TallyLedgersMapping() {

    const TABLE_HEAD = [
        {
            field: 'Tally Ledger Name', headerName: 'Tally Ledger Name', flex: 1.8
        },
        {
            field: 'Mapped Client Name', headerName: 'Mapped Ledger Name', flex: 1.5
        },
        {
            field: 'Mapped Contact Id', headerName: 'Mapped Contact ID', flex: 1.2
        },
        {
            field: 'Client Alias', headerName: 'Client Alias', flex: 1
        },
        {
            field: 'Site', headerName: 'Site', flex: 0.5
        },
        {
            field: 'Debtors', headerName: 'Debtors', flex: 0.6
        },
        {
            field: 'Creditors', headerName: 'Creditors', flex: 0.6
        },
        {
            field: 'Others', headerName: 'Others', flex: 0.5
        },
        {
            field: 'Inserted On', headerName: 'Inserted Date', flex: 1,
            renderCell: (params) => Moment(params.value).format('DD-MMM-YYYY')
        },
        {
            field: 'Industry', headerName: 'Industry', flex: 1.5
        },
        {
            field: 'Customer Type', headerName: 'Customer Type', flex: 1
        },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            flex: 0.2,
            headerAlign: 'right', // Align header to the right
            align: 'right', // Align content to the right
            renderCell: (cellValues) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <IconButton
                        onClick={(event) => {
                            handleClick(event, cellValues);
                        }}
                    >
                        <Iconify icon="ic:outline-edit" width='20px' height='20px' color='primary.main' />
                    </IconButton>
                </div>
            )
        }
    ];

    const VoucherColumn = [
        {
            field: 'Voucher Type', headerName: 'VoucherType', flex: 1
        },
        {
            field: 'Voucher No', headerName: 'Voucher No', flex: 1
        },
        {
            field: 'Voucher Date', headerName: 'Voucher Date', flex: 1
        },
        {
            field: 'Tally Ledger Name', headerName: 'Tally Ledger Name', flex: 1
        },
        {
            field: 'Tallly Product Name', headerName: 'Tallly Product Name', flex: 1
        },
        
    ];
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const [mappingType, setMappingType] = useState(2 || '');
    const [selectedMappingType, setSelectedMappingType] = useState([]);

    const [tallyLedgerFilterData, setTallyLedgerFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [pageSize1, setPageSize1] = useState(25);
    const [pageSize2, setPageSize2] = useState(25);
    const [rowData, setRowData] = useState({});
    const [radio, setRadio] = useState("");

    const [client, setClient] = useState('');
    const [selectedClient, setSelectedClient] = useState([]);

    const [industry, setIndustry] = useState('');
    const [selectedIndustry, setSelectedIndustry] = useState([]);

    const [customerType, setCustomerType] = useState('');
    const [selectedCustomerType, setSelectedCustomerType] = useState([]);

    const [voucherData, setVoucherData] = useState([]);

    const handleClient = (newValue) => {
        setClient(newValue?.ContactId || "");
    };
    const handleRadioChange = (event) => {
        const selectedValue = Number(event.target.value); // Convert string to number
        setRadio(selectedValue);
        setClient("");
    };
    console.log("radio>>>>>>>>>>>", radio)

    const handleIndustry = (id) => {
        setIndustry(id);
    };
    const handleCustomerType = (id) => {
        setCustomerType(id);
    };
    const handleMappingType = (event) => setMappingType(event.target.value);
    const CustomPagination = (props) => <GridPagination {...props} />;

    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setUserName(CurrentLoggedInUser.ExecutiveName);
        URLS.getMappingType()
            .then((response) => setSelectedMappingType(response.data.data))
            .catch(error => console.log("Error", error));
        URLS.getClientMasterData()
            .then((response) => setSelectedClient(response.data))
            .catch(error => console.log("Error", error));
        URLS.getIndustryList()
            .then((response) => setSelectedIndustry(response.data))
            .catch(error => console.log("Error", error));
        URLS.getCustomerTypeList()
            .then((response) => setSelectedCustomerType(response.data))
            .catch(error => console.log("Error", error));
    
    }, []);

    // Filter function
    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            MappingType: mappingType,
        };
        URLS.tallyLedgerFilter(payload)
            .then((response) => {
                setIsLoading(false);
                setTallyLedgerFilterData(response.data)
                enqueueSnackbar("Fetched Data Successfully", { variant: 'success' });

            })
            .catch(error => {
                setIsLoading(false);
                setTallyLedgerFilterData([]);
                enqueueSnackbar("Data not found", { variant: 'success' });

            });
    };
    const handleClick = (event, cellValues) => {
        const rowData = cellValues.row
        setRowData(rowData);
        if (rowData.Debtors) {
            setRadio(0);
        } else if (rowData.Creditors) {
            setRadio(1);
        } else if (rowData.Others) {
            setRadio(2);
        } else {
            setRadio(""); // Default state if none are true
        }
        setClient(rowData["Mapped Contact Id"] || "");
        setIndustry(selectedIndustry.find((item) => item.Name === rowData.Industry)?.Id || ""); 
        setCustomerType(selectedCustomerType.find((item) => item.Name === rowData["Customer Type"])?.Id || "");

        setOpenModal(true);

        URLS.getVoucherList({ TallyLedgerName: rowData["Tally Ledger Name"] })
            .then((response) => setVoucherData(response.data))
            .catch(error => setVoucherData([]));
    };
    console.log("click>>>>>>>>>>>>>>>>>.", rowData, rowData.Industry)


    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const onResetClick = () => {
        setMappingType(2 || '');
        setTallyLedgerFilterData([]);
    };

    const updateTallyData = () => {

        setIsLoading(true);
        console.log(">>>>>>>>>", client, rowData?.Debtors, radio === 0)
        if ((!client && rowData?.Debtors === true) || (!client && radio === 0)) {
            enqueueSnackbar("Please select a client");
            return;
         }

        const payload =
        {
            "TallyLedgerName": rowData["Tally Ledger Name"] || "",
            "Industry": selectedIndustry.find(item => item.Id === industry)?.Name || "",
            "CustomerType": selectedCustomerType.find(item => item.Id === customerType)?.Name || "",
            "ContactId": (radio === 1 || radio === 2 || radio === "") ? 0 : client,
            "Debtors": Boolean(radio === 0) || false,
            "Creditors": Boolean(radio === 1) || false,
            "Others": Boolean(radio === 2) || false
        }
       
        URLS.updateLedgerMapping(payload)
            .then((response) => {
                if (response.status === 200) {
                    setOpenModal(false);
                    setIsLoading(false);
                    enqueueSnackbar("Data updated successfully.", { variant: 'success' });
                    onFilterClick();
                }
                
            })
            .catch(error => {
                enqueueSnackbar("Failed to update data.", { variant: 'error' });
                setIsLoading(false);
            });

    }

    useEffect(() => {
        setMappingType(2 || '');
        setTallyLedgerFilterData([]);
    }, [location.key]);

    console.log("disable>>>>>>>>>>>>>>>>>>>>", radio , rowData?.Debtors)


    return (

        <Page title="Tally Ledgers Mapping" >
          
            <StickyHeader title="Tally Ledgers Mapping" />

            <Card >

                <Stack direction="row" alignItems="center" justifyContent="space-between" m={1} spacing={1}>
                    <FormControl fullWidth size="small">
                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>
                            Mapping Type
                        </InputLabel>
                        <Select
                            label="Mapping Type"
                            size="small"
                            value={mappingType}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7',
                                        maxHeight: '200px',
                                    },
                                },
                            }}
                            style={{ width: '32%' }}
                            onChange={handleMappingType}
                        >
                            <MenuItem key={0} value={""} >Select</MenuItem>

                            {selectedMappingType.map((mapping) => (
                                <MenuItem
                                    key={mapping.Id}
                                    value={mapping.Id}
                                >
                                    {mapping.Type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Modal open={openModal} onClose={handleCloseModal}>
                        <Box sx={style}>
                            <Stack spacing={1}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Typography variant="body2">
                                        Tally Ledger Name: {rowData["Tally Ledger Name"]}
                                    </Typography>
                                    <RadioGroup row value={radio} onChange={handleRadioChange}>
                                        <FormControlLabel
                                            value={0}
                                            control={<Radio />}
                                            label="Debtor"
                                            checked={radio === 0}
                                            disabled={rowData?.Debtors === true}
                                        />
                                        <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            label="Creditor"
                                            checked={radio === 1}
                                            disabled={rowData?.Debtors === true}
                                        />
                                        <FormControlLabel
                                            value={2}
                                            control={<Radio />}
                                            label="Others"
                                            checked={radio === 2}
                                            disabled={rowData?.Debtors === true}
                                        />
                                    </RadioGroup>

                                    
                                </Stack>
                                <Stack direction="row" spacing={2} alignItems="center">

                                    <FormControl
                                        size="small"
                                        fullWidth
                                    >
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="Clients"
                                            value={selectedClient.find((option) => option.ContactId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ContactId === value.ContactId}
                                            renderInput={(params) => <TextField {...params} label="Clients" />}
                                            disableClearable
                                            disabled={rowData?.Debtors === false && radio !== 0}

                                        />
                                    </FormControl>
                                    <FormControl
                                        size="small"
                                        fullWidth
                                    >
                                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Industry</InputLabel>
                                        <Select
                                            label="Industry"
                                            size="small"
                                            value={industry} // Bind the 'value' prop to the 'orderBy' state
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7', // Set the background color
                                                        maxHeight: '200px',
                                                        width: '200px', // Set max height and width
                                                    }
                                                }
                                            }}
                                            onChange={(e) => handleIndustry(e.target.value)} // Update state when selection changes
                                        >
                                            {selectedIndustry.map((order) => (
                                                <MenuItem key={order.Id} value={order.Id}>
                                                    {order.Name} {/* Display the value (Asc or Desc) */}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </FormControl>
                                    <FormControl
                                        size="small"
                                        fullWidth
                                    >
                                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Customer Type</InputLabel>
                                        <Select
                                            label="Customer Type"
                                            size="small"
                                            value={customerType} // Bind the 'value' prop to the 'orderBy' state
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: '#fbe9e7', // Set the background color
                                                        maxHeight: '200px',
                                                        width: '200px', // Set max height and width
                                                    }
                                                }
                                            }}
                                            onChange={(e) => handleCustomerType(e.target.value)} // Update state when selection changes
                                        >
                                            {selectedCustomerType.map((order) => (
                                                <MenuItem key={order.Id} value={order.Id}>
                                                    {order.Name} {/* Display the value (Asc or Desc) */}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </FormControl>
                                </Stack>
                                <Stack direction="row" justifyContent="center" spacing={2} >
                                    <Button
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        sx={{ color: "white" }}
                                        onClick={updateTallyData}
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        sx={{ color: "white" }}
                                        onClick={handleCloseModal}
                                        size="medium"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Close
                                    </Button>
                                </Stack>
                                 <Stack direction="row" spacing={2} alignItems="center"> 
                                    <div style={{ height: '55vh', width: '100%' }}> 
                                        <DataGrid 
                                            rows={voucherData} 
                                           columns={VoucherColumn} 
                                            density="compact" 
                                            getRowId={(row) => voucherData.indexOf(row)}
                                            getRowHeight={() => 'auto'}
                                            components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                            pagination
                                            paginationMode="client"
                                            rowsPerPageOptions={[25, 50, 100]}
                                            pageSize={pageSize2}
                                            onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                            sx={{

                                                '& .MuiDataGrid-iconSeparator': {
                                                    display: "none", // Removes the separator
                                                },
                                                '& .MuiDataGrid-row:nth-of-type(even)': {
                                                    backgroundColor: 'white', // Even rows: White
                                                },
                                                '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                    backgroundColor: '#f5f3f2', // Odd rows: Blue
                                                    color: 'bleck', // Set text color to white for better contrast
                                                },
                                            }}
                                        /> 
                                    </div> 
                                 </Stack> 

                            </Stack>
                        </Box>
                    </Modal>
                    <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                        <Tooltip title="Filter">

                            <Button
                                variant="contained"
                                size="small"
                                onClick={onFilterClick}
                            ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                        </Tooltip >
                        <Tooltip title="Reset">
                            <Button
                                variant="contained"
                                size="small"
                                onClick={onResetClick}
                            ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>
                        </Tooltip >

                    </Stack>
                </Stack>
                <Divider />

                {/* ----------------------------------------------------------------- */}

                <div style={{ height: '73vh', width: '100%' }}>
                    <DataGrid
                        rows={tallyLedgerFilterData}
                        density={'compact'}
                        columns={TABLE_HEAD}
                        getRowId={(row) => row.id || tallyLedgerFilterData.indexOf(row)}

                        getRowHeight={() => 'auto'}
                        components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                        pagination
                        paginationMode="client"
                        rowsPerPageOptions={[25, 50, 100]}
                        pageSize={pageSize1}
                        onPageSizeChange={(newPageSize) => setPageSize1(newPageSize)}
                        sx={{

                            '& .MuiDataGrid-iconSeparator': {
                                display: "none", // Removes the separator
                            },
                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                backgroundColor: 'white', // Even rows: White
                            },
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                backgroundColor: '#f5f3f2', // Odd rows: Blue
                                color: 'bleck', // Set text color to white for better contrast
                            },
                        }}
                    />

                </div>

            </Card>
            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}


        </Page>


    );
}
